import { useInfiniteQuery } from "@tanstack/react-query"
import { makeApiRequest } from "@/src/lib/api-request"
import {useToken} from '@/src/store/token-store'

interface Subscription {
    channelId: string,
    subscriberCount: string,
    videoCount:string,
    firstName: string,
    imageUrl: string,
    channelName: string,
    channelShareName:string,
    isVerifiedTick:string,
    themeColor: string
}

interface SubscriptionDetailsResponse {
    offset : number,
    subscriptions : Subscription[]
}

export const useSubscriptionDetailsQuery = () => {
    const {accessToken} = useToken()
    return useInfiniteQuery({initialPageParam: { offset: 0 },
        queryKey: ['subscription-details', accessToken],
        queryFn: async ({ pageParam }): Promise<SubscriptionDetailsResponse> => {
            const newOffset = pageParam.offset
          
            const dataProps = {
                limit: 10,
                offset: newOffset,
            }
            const response = await makeApiRequest({
                method: 'POST',
                url: '/Subscribe/getSubscriptionDetails',
                isAuthenticated: true,
                data: dataProps,
                fallbackError: 'Error while fetching subscription channels',
                isV3Api: true
            })
            const subscriptions: Subscription[] = response.response.data
            return { subscriptions, offset: newOffset }
        },
        getNextPageParam: (lastPage) => {
          if (lastPage.subscriptions?.length === 0) return undefined
          const newOffset = lastPage.offset + 10
          return { offset: newOffset }
        },
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        enabled: !!accessToken
      })
}